import { React, PT, connect, Redirect, withRouter } from '@gasbuddy/react';
import qs from 'querystring';
import { Container } from 'semantic-ui-react';
import { VerticalCenter } from '../../components/vertical-center';
import { LoginForm, LoginStatus } from '../../components/auth';
import { Action } from '../../reducers';

function beginAuthentication(dispatch, body) {
  dispatch({
    type: Action.Auth.LoginRequested,
    meta: { apiAction: true },
    payload: {
      url: '/auth/login',
      body,
    },
  });
}

const BaseLoginPage = (props) => {
  const { account_id: aid, status, failure, location, dispatch } = props;
  if (aid) {
    let destination = '/';
    if (location && location.search) {
      destination = qs.parse(location.search.substring(1)).returnUrl;
    }
    return (
      <Redirect to={destination} />
    );
  }
  return (
    <VerticalCenter>
      <Container text>
        <LoginForm
          status={status}
          failure={failure}
          beginAuthentication={c => beginAuthentication(dispatch, c)}
        />
      </Container>
    </VerticalCenter>
  );
};

BaseLoginPage.propTypes = {
  status: PT.number,
  account_id: PT.string,
  failure: PT.string,
  location: PT.shape({ search: PT.string }).isRequired,
  dispatch: PT.func.isRequired,
};

BaseLoginPage.defaultProps = {
  account_id: null,
  status: LoginStatus.LoggedOut,
  failure: null,
};

export default connect(({ auth }) => auth)(withRouter(BaseLoginPage));
